// src/entities/form/model-tailwind/with-form-state.tsx
'use client';

import { Controller, useFormContext } from 'react-hook-form';
import type { FC } from 'react';
import type { BaseFieldProps } from './form.model';

export const withFormState = <TProps extends BaseFieldProps = BaseFieldProps>(Component: FC<TProps>): FC<TProps> => {
  const Wrapped: FC<TProps> = (props) => {
    const { control } = useFormContext();
    return <Controller name={props.name} control={control} render={({ field, fieldState: { error } }) => <Component {...field} {...props} error={error?.message} />} />;
  };
  Wrapped.displayName = `WithFormState(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
};
